// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CardGroup_wrapper__xAmxz"};